export const T = {
  en_GB: {
    edit: "Edit",
    manualFees: "Manual Fees",
    description:
      "Flat percentage fees entered manually (no data-provider sync), with an optional minimum amount on deposit/withdrawal fees.",
    addManualFee: "Add Manual Fee",
    noManualFees: 'No manual fees configured. Click "Add Manual Fee" to create one.',
    name: "Name",
    category: "Category",
    rate: "Rate",
    minFee: "Min. fee",
    scope: "Applies to",
    any: "Any",
    actions: "Actions",
    none: "—",
    deleteManualFee: "Delete Manual Fee",
    deleteConfirmation:
      "Are you sure you want to delete this manual fee? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    manualFeeDeleted: "Manual fee deleted successfully",
    error: "Error",
    failedToDelete: "Failed to delete manual fee",
    categoryRecurring: "Recurring",
    categoryDeposit: "Deposit",
    categoryWithdrawal: "Withdrawal",
  },
  nb_NO: {
    edit: "Rediger",
    manualFees: "Manuelle kostnader",
    description:
      "Faste prosentavgifter lagt inn manuelt (uten datasynkronisering), med valgfritt minimumsbeløp på innskudds-/uttaksavgifter.",
    addManualFee: "Legg til manuell kostnad",
    noManualFees: 'Ingen manuelle kostnader konfigurert. Klikk "Legg til manuell kostnad".',
    name: "Navn",
    category: "Kategori",
    rate: "Sats",
    minFee: "Min. avgift",
    scope: "Gjelder for",
    any: "Alle",
    actions: "Handlinger",
    none: "—",
    deleteManualFee: "Slett manuell kostnad",
    deleteConfirmation:
      "Er du sikker på at du vil slette denne manuelle kostnaden? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    manualFeeDeleted: "Manuell kostnad slettet",
    error: "Feil",
    failedToDelete: "Kunne ikke slette manuell kostnad",
    categoryRecurring: "Løpende",
    categoryDeposit: "Innskudd",
    categoryWithdrawal: "Uttak",
  },
} as const;
